const categories = [
  {
    title: 'Продажи',
    icon: 'ri-funds-line',
    color: 'teal',
    skills: ['Переговоры', 'Работа с возражениями', 'Выявление потребностей', 'Презентация и аргументация', 'Развитие клиентов и кросс-продажи']
  },
  {
    title: 'Руководители',
    icon: 'ri-shield-star-line',
    color: 'amber',
    skills: ['Лидерство и мотивация', 'Делегирование и контроль', 'Обратная связь и развитие сотрудников', 'Управление командой', 'Управление изменениями']
  },
  {
    title: 'Soft Skills',
    icon: 'ri-heart-line',
    color: 'rose',
    skills: ['Коммуникация и переговоры', 'Эмоциональный интеллект', 'Стрессоустойчивость', 'Управление временем', 'Публичные выступления']
  },
  {
    title: 'Команды',
    icon: 'ri-team-line',
    color: 'indigo',
    skills: ['Командное взаимодействие', 'Фасилитация встреч', 'Тимбилдинг и доверие', 'Доверие и сотрудничество', 'Решение конфликтов']
  }
];

const colorMap: Record<string, { bg: string; text: string; badge: string; badgeText: string }> = {
  teal: { bg: 'bg-teal-50/70', text: 'text-teal-800', badge: 'bg-teal-600', badgeText: 'text-white' },
  amber: { bg: 'bg-amber-50/70', text: 'text-amber-800', badge: 'bg-amber-500', badgeText: 'text-white' },
  rose: { bg: 'bg-rose-50/70', text: 'text-rose-800', badge: 'bg-rose-500', badgeText: 'text-white' },
  indigo: { bg: 'bg-indigo-50/70', text: 'text-indigo-800', badge: 'bg-indigo-500', badgeText: 'text-white' },
};

export default function WhatCompetenciesDevelop() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Какие компетенции можно развивать
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Программа обучения может развивать компетенции по четырём ключевым направлениям — в зависимости от бизнес-задач компании
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((c, i) => (
            <div key={i} className={`rounded-2xl p-6 border border-gray-100 ${colorMap[c.color].bg}`}>
              <div className={`w-12 h-12 ${colorMap[c.color].badge} rounded-xl flex items-center justify-center mb-4`}>
                <i className={`${c.icon} text-xl ${colorMap[c.color].badgeText}`}></i>
              </div>
              <h3 className={`text-lg font-bold mb-4 ${colorMap[c.color].text}`}>{c.title}</h3>
              <div className="space-y-2">
                {c.skills.map((s, j) => (
                  <div key={j} className="flex items-center gap-2">
                    <i className="ri-check-line text-teal-500 text-sm"></i>
                    <span className="text-gray-700 text-sm">{s}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}